module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dark"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-left center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/origins-of-type"
    }
  }, [_vm._v("▲"), _c('br'), _vm._v("Origins of Type")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "side-nav side-nav-right center"
  }, [_c('div', {
    staticClass: "rotate"
  }, [_c('router-link', {
    attrs: {
      "to": "/letter-form-anatomy"
    }
  }, [_vm._v("Letter-form Anatomy"), _c('br'), _vm._v("▼")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content--first blue clear"
  }, [_c('hangul-blocks-slides')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content lightblue"
  }, [_c('div', {
    staticClass: "spacer--medium"
  }), _vm._v(" "), _c('div', {
    staticClass: "column--single text--blue"
  }, [_vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('hangul-blocks')], 1), _vm._v(" "), _c('div', {
    staticClass: "clear spacer--medium"
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer--medium center"
  }, [_c('router-link', {
    staticClass: "button caps",
    attrs: {
      "to": "/letter-form-anatomy"
    }
  }, [_vm._v("Next Chapter")])], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrap clear"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-section-title caps rotate"
  }, [_vm._v("\n          The Basics\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-section-number"
  }, [_vm._v("1–2")]), _vm._v(" "), _c('h1', [_vm._v("Hangul Blocks")]), _vm._v(" "), _c('p', {
    staticClass: "header-section-desc"
  }, [_vm._v("Making words is like playing Tetris—from the start Korean letters were created modularly.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content mediumblue"
  }, [_c('div', {
    staticClass: "spacer--medium"
  }), _vm._v(" "), _c('div', {
    staticClass: "column--single"
  }, [_c('div', {
    staticClass: "column--single text--lightpink rule img--100"
  }, [_c('h2', {
    staticClass: "center caps"
  }, [_vm._v("Consonants are Square")]), _vm._v(" "), _c('p', {
    staticClass: "serif center"
  }, [_vm._v("Based on the physical forms of the tongue, mouth, and throat.")]), _vm._v(" "), _c('div', {
    staticClass: "flex--center"
  }, [_c('div', {
    staticClass: "column--one-fourth spacer--medium"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/hangul-blocks/consonants.gif",
      "alt": "Hangul Consonants"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/hangul-blocks/consonants-array.svg",
      "alt": "Hangul Consonants Array"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--single text--yellow img--100 spacer--medium"
  }, [_c('h2', {
    staticClass: "center caps"
  }, [_vm._v("Vowels are Rectangular")]), _vm._v(" "), _c('p', {
    staticClass: "serif center"
  }, [_vm._v("Based on the harmony of the earth, yin (earth) and yang (sky).")]), _vm._v(" "), _c('div', {
    staticClass: "flex--center"
  }, [_c('div', {
    staticClass: "column--one-fourth spacer--medium"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/hangul-blocks/vowels.gif",
      "alt": "Hangul Vowels"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--three-fourths"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/hangul-blocks/vowels-array.svg",
      "alt": "Hangul Vowels Array"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column--single"
  }, [_c('h2', {
    staticClass: "center caps"
  }, [_vm._v("Character Blocks")]), _vm._v(" "), _c('div', {
    staticClass: "serif center caption"
  }, [_c('img', {
    staticClass: "img--middle img--icon",
    attrs: {
      "src": "/static/images/tap-icon.svg",
      "alt": "TAP"
    }
  }), _vm._v(" Tap each character block\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "clear spacer--small"
  }), _vm._v(" "), _c('div', {
    staticClass: "serif center caption clear"
  }, [_c('div', {
    staticClass: "column--one-third"
  }, [_c('img', {
    staticClass: "img--middle",
    attrs: {
      "src": "/static/images/hangul-blocks/key--consonant-first.png",
      "alt": "First Consonant"
    }
  }), _vm._v(" First Consonant "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("(초성)")])]), _vm._v(" "), _c('div', {
    staticClass: "column--one-third"
  }, [_c('img', {
    staticClass: "img--middle",
    attrs: {
      "src": "/static/images/hangul-blocks/key--vowel.png",
      "alt": "Vowel(s)"
    }
  }), _vm._v(" Vowel(s) "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("(중성)")])]), _vm._v(" "), _c('div', {
    staticClass: "column--one-third"
  }, [_c('img', {
    staticClass: "img--middle",
    attrs: {
      "src": "/static/images/hangul-blocks/key--consonant-second.png",
      "alt": "Vowel(s)"
    }
  }), _vm._v(" Last Consonant "), _c('span', {
    staticClass: "kr-serif"
  }, [_vm._v("(종성)")])])]), _vm._v(" "), _c('div', {
    staticClass: "spacer--small clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4317c3e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HangulBlocks.vue
// module id = 143
// module chunks = 0